var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "peppol-interpreter" },
    [
      _vm.interpretation.rule === "delivery"
        ? [
            _c("el-alert", {
              attrs: {
                title: _vm.$t(_vm.interpretation.titleKey),
                type: "success",
                closable: false,
                "show-icon": ""
              }
            })
          ]
        : _vm.interpretation.rule === "bounce-403"
        ? [
            _c("el-alert", {
              attrs: {
                title: _vm.$t(_vm.interpretation.titleKey),
                type: "error",
                closable: false,
                "show-icon": ""
              }
            }),
            _vm._v(" "),
            _vm.interpretation.fields.length
              ? _c(
                  "el-descriptions",
                  {
                    staticClass: "mt-10",
                    attrs: { column: 1, border: "", size: "small" }
                  },
                  _vm._l(_vm.interpretation.fields, function(field, idx) {
                    return _c(
                      "el-descriptions-item",
                      { key: idx, attrs: { label: _vm.fieldLabel(field.key) } },
                      [_vm._v("\n\t\t\t\t" + _vm._s(field.value) + "\n\t\t\t")]
                    )
                  }),
                  1
                )
              : _vm._e()
          ]
        : _vm.interpretation.rule === "bounce-400"
        ? [
            _c("el-alert", {
              attrs: {
                title: _vm.$t(_vm.interpretation.titleKey),
                type: "error",
                closable: false,
                "show-icon": ""
              }
            }),
            _vm._v(" "),
            _vm.interpretation.errors.length
              ? _c(
                  "el-table",
                  {
                    staticClass: "mt-10",
                    staticStyle: { width: "100%" },
                    attrs: {
                      data: _vm.interpretation.errors,
                      size: "mini",
                      stripe: ""
                    }
                  },
                  [
                    _c("el-table-column", {
                      attrs: {
                        prop: "id",
                        label: _vm.$t(
                          "interchangeEventDetail.peppol.validationColId"
                        ),
                        width: "90"
                      }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "level",
                        label: _vm.$t(
                          "interchangeEventDetail.peppol.validationColLevel"
                        ),
                        width: "90"
                      }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "fieldName",
                        label: _vm.$t(
                          "interchangeEventDetail.peppol.validationColField"
                        ),
                        "min-width": "120"
                      }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "description",
                        label: _vm.$t(
                          "interchangeEventDetail.peppol.validationColDescription"
                        ),
                        "min-width": "180"
                      }
                    })
                  ],
                  1
                )
              : _vm._e()
          ]
        : _vm.interpretation.rule === "processing"
        ? [
            _c(
              "el-alert",
              {
                attrs: {
                  title: _vm.$t(_vm.interpretation.titleKey),
                  type: _vm.interpretation.alertType,
                  closable: false,
                  "show-icon": ""
                }
              },
              [
                _vm.interpretation.detail
                  ? _c("p", { staticClass: "peppol-interpreter__detail" }, [
                      _vm._v(
                        "\n\t\t\t\t" +
                          _vm._s(_vm.interpretation.detail) +
                          "\n\t\t\t"
                      )
                    ])
                  : _vm._e()
              ]
            )
          ]
        : _vm.interpretation.rule === "transit"
        ? [
            _c("el-alert", {
              attrs: {
                title: _vm.$t(_vm.interpretation.titleKey),
                type: "info",
                closable: false,
                "show-icon": ""
              }
            })
          ]
        : [
            _vm.interpretation.statusText
              ? _c(
                  "el-descriptions",
                  { attrs: { column: 1, border: "", size: "small" } },
                  [
                    _c(
                      "el-descriptions-item",
                      {
                        attrs: {
                          label: _vm.$t("interchangeEventDetail.status")
                        }
                      },
                      [
                        _vm._v(
                          "\n\t\t\t\t" +
                            _vm._s(_vm.interpretation.statusText) +
                            "\n\t\t\t"
                        )
                      ]
                    )
                  ],
                  1
                )
              : _vm._e()
          ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }